const AllGeneralTraining = () => import("./views/AllGeneralTraining.vue");
const ViewTrainingDetails = () => import("./views/ViewTrainingDetails.vue");
const AllPerformanceImprovementPlan = () =>
  import("./views/AllPerformanceImprovementPlan.vue");

export default [
  {
    path: "general-training",
    component: AllGeneralTraining,
  },
  {
    path: "general-training/view/:id",
    component: ViewTrainingDetails,
  },
  {
    path: "performance-improvement-plan",
    component: AllPerformanceImprovementPlan,
  },
  {
    path: "performance-improvement-plan/create",
    redirect: "/ess/performance/training/performance-improvement-plan",
  },
  {
    path: "settings",
    redirect: "/ess/performance/training/general-training",
  },
  {
    path: "manage-general-settings",
    redirect: "/ess/performance/training/general-training",
  },
  {
    path: "manage-performance-improvement",
    redirect: "/ess/performance/training/performance-improvement-plan",
  },
  {
    path: "settings/assign-employee",
    redirect: "/ess/performance/training/general-training",
  },
];
